import React, { Dispatch, SetStateAction } from 'react';
import {
  View, StyleSheet, TextInput, Platform,
} from 'react-native';
import Colors from '../../constants/Colors';
import SearchIcon from '../SearchIcon';
import Button from '../Button';
import isMobile from '../IsMobile';

interface NotificationSearchProps {
  search: () => void,
  value: string,
  onChangeText: Dispatch<SetStateAction<string>>,
}

const NotificationSearch = ({ search, value, onChangeText }: NotificationSearchProps) => <View
  style={styles.container}
>
  <SearchIcon />
  <TextInput
    style={styles.input}
    placeholder='Search'
    placeholderTextColor={Colors.light.hereworksBlack400}
    {...{ value, onChangeText }}
    onSubmitEditing={search}
  />
  {value?.length > 0 && <Button
    affirmative
    style={styles.searchButton}
    title='Search'
    onPress={search}
  />}
</View>;

const styles = StyleSheet.create({
  container: {
    borderWidth: 1,
    borderColor: Colors.light.hereworksBlue100,
    paddingHorizontal: 12,
    paddingVertical: 8,
    alignItems: 'center',
    flexDirection: 'row',
    marginBottom: isMobile ? 12 : 30,
    borderRadius: 10,
    backgroundColor: '#FFF',
  },
  input: {
    fontSize: 14,
    lineHeight: Platform.OS === 'ios' ? undefined : 21,
    fontFamily: 'Poppins_400Regular',
    color: Colors.light.hereworksBlack400,
    marginStart: 8,
    flex: 1,
    outlineWidth: 0,
  },
  searchButton: {
    paddingHorizontal: 12,
    paddingVertical: 2,
    flex: undefined,
  },
});

export default NotificationSearch;
